'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _Helper = require('./Helper');

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};
//类型支持的组件


// TODO TREE

/**
 * 把属性绑定上来
 */
var CustomBillItem = (0, _createReactClass2.default)({
  initialed: false,
  propTypes: {
    Component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {};
  },
  /**
   * 对传入的model进行拆分 进行parse
   */
  getInitialState: function getInitialState() {
    return this.init(this.props);
  },
  /**
   * 初始化model
   */
  init: function init(props) {
    var state;
    if (!_lodashCompat2.default.isEmpty(props.model)) {
      this.bill = props.parent;
      this.initialed = true;
      // 把配置文件里的属性都挪到外层来,方便获取
      state = Object.assign({}, props, props.model, { model: props.model });
      state.size = state.size || props.size;
      state.alignment = _Helper.ALIGNMENT[state.alignment || props.alignment] || _Helper.ALIGNMENT.right;
      state.prefixCls = state.prefixCls || props.prefixCls;
      props.mode === 'view' && (state.mode = 'view');
      state.onChange = props.onChange;
      state.parent = props.parent;
      state.show = ![false, 'false'].includes(props.model.show);
      props.onFetchData && (state.onFetchData = props.onFetchData);
    }
    return state;
  },
  shouldComponentUpdate: function shouldComponentUpdate(props, state) {
    return this.state !== state;
  },
  /*
   * 同理只认第一次传入的model
   */
  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (!props.updateHandly || !this.initialed) {
      var state = this.init(props);
      this.setState(state);
    }
  },
  render: function render() {
    if (!this.initialed) {
      return null;
    }
    var _state = this.state;

    var props = _objectWithoutProperties(_state, []);

    var show = _state.show;
    var _props = this.props;
    var Component = _props.Component;
    var parent = _props.parent;
    // TODO 对于 show 为 false 的自定义组件，进行隐藏

    return (0, _data.getComponent)(Component, _extends({}, props, { parent: parent }), 'element');
  },
  /**
   * 被外部赋值过来
   */
  setValue: function setValue(value) {
    var self = this;
    // 第一步 赋值
    this.setState({ value: value }, function () {
      var fetchEvent = self.bill.fetchs[self.state.code],
          controlEvent = self.bill.controls[self.state.code];
      // 第二步 fetch 判断本身是否有fetch 需不需要触发fetch
      if (fetchEvent && fetchEvent.auto) {
        //去获取数据 然后赋值
        self.parent.doFetchHandler(self.props.model, fetchEvent);
      }
      // 第三步 control 判断本身是否有control 触发control
      if (controlEvent) {
        //解析control
        self.bill.doControlHandler(self.state.code, self.bill.getData()[self.state.code], controlEvent);
      }
    });
  },
  /**
   * 获取数据
   */
  getValue: function getValue() {
    return (0, _data.getSafetyString)(this.state.value);
  },
  /**
   * 清空其他zhuangtai
   */
  clear: function clear() {
    if (this.refs.element && this.refs.element.clear) {
      this.refs.element.clear();
    }
  },
  /**
   * 重置组件的状态
   */
  reset: function reset() {
    this.setState({ value: "" });
    if (this.refs.element && this.refs.element.reset) {
      this.refs.element.reset();
    }
  },
  /**
   * 校验
   */
  validate: function validate() {
    if (!this.state.show) return true;
    if (this.refs.element && this.refs.element.validate) {
      return this.refs.element.validate();
    }
    return true;
  },
  /**
   * 变更显示
   * @param model 更新state
   */
  updateModel: function updateModel(model) {
    if (!_lodashCompat2.default.isEmpty(model)) {
      var state = this.init(Object.assign({}, this.props, { model: Object.assign({}, this.props.model, model) }));
      this.setState(state);
    }
  }
});

module.exports = CustomBillItem;